import { TimeOccurrenceEngine } from '../engines/time/time_engine';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { ICorrector } from './contracts';

angular
  .module('ui-ng-calendar')
  .factory('reconcileOverlappingTimesCorrectorFactory', function (ngTimeOccurrenceEngine: TimeOccurrenceEngine) {
    return (
      overlappingTimes: ITimeOccurrenceDatatype[],
      currentTimeOccurrence: ITimeOccurrenceDatatype,
      originalTimeOccurrence: ITimeOccurrenceDatatype
    ): ICorrector =>
      function reconcileOverlappingTimesCorrector(store: ITimeOccurrenceDatatype[]) {
        let timeGroups = _.partition(overlappingTimes, (time) => !time.isLocked);
        let mergeableTimes = _.first(timeGroups);

        let mergedTime = _.reduce(mergeableTimes, (acc: ITimeOccurrenceDatatype, time: ITimeOccurrenceDatatype) => {
          return ngTimeOccurrenceEngine.createMergedTime(acc, time);
        });

        let lockedTimes = _.last(timeGroups);

        let splitTimes = ngTimeOccurrenceEngine.createSplitTimes(mergedTime, lockedTimes);

        _.each(splitTimes, (time: ITimeOccurrenceDatatype) => {
          store.push(time);
        });

        _.remove(store, originalTimeOccurrence);

        _.each(mergeableTimes, (mergeableTime: ITimeOccurrenceDatatype) => {
          _.remove(store, mergeableTime);
        });

        return store;
      };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/validation/reconcile_overlapping_times_corrector.ts